import React from 'react'

const Artsandcreations = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Circle the correct meanings of the underlined words.</p>
        <p>a. Martin Luther started a revolt against the conventions of the Roman Catholic Church.</p>
        <strong>creations</strong>
        <p>b. It blended classical styles with new ideas.</p>
        <strong>mixed together</strong>
        <p>c. The dome marks the beginning of Renaissance architecture.</p>
        <strong>serves as a sign of</strong>
        <p>d. The arts flourished during the Renaissance.</p>
        <strong>grew and improved</strong>
        <p>e. The new passion for learning also led to amazing discoveries in science.</p>
        <strong>enthusiasm</strong>
      </div>
      <hr/>
      <div>
        <p className='question'>C. What do the following idioms mean? Use them in sensible sentences.</p>
        <p><strong>a. a hot potato : </strong>A difficult or controversial situation</p>
        <p>The issue of raising taxes is a hot potato that politicians try to avoid talking about during elections.</p>
        <br/>
        <p><strong>b. once in a blue moon : </strong>Something that happens very rarely</p>
        <p>I only see my cousins once in a blue moon because they live in a different country.</p>
        <br/>
        <p><strong>c. a bed of roses : </strong>A situation that is comfortable, easy</p>
        <p>Life isn't always a bed of roses; sometimes we have to face challenges and hardships.</p>
        <br/>
        <p><strong>d. when pigs fly : </strong>Something that will never happen </p>
        <p>She promised to wake up early every day, but that will happen when pigs fly.</p>
        <br/>
        <p><strong>e. miss the boat : </strong>miss an opportunity.</p>
        <p>I didn't apply for the scholarship on time, so I missed the boat.</p>
        <br/>
        <p><strong>f. zip your lip : </strong>to be quiet or stop talking</p>
        <p>Please zip your lip during the movie so everyone can enjoy it.</p>
        <br/>
        <p><strong>g. fight tooth and nail : </strong>to fight very fiercely or with great determination.</p>
        <p>She fought tooth and nail to win the championship despite all the challenges.</p>
        <br/>
        <p><strong>h. when life gives you lemon, make lemonade : </strong>to make the best out of a bad</p>
        <p>Even though she lost her job, she stayed positive and started her own business truly making lemonade when life gave her lemons.</p>
        <br/>
        <p><strong>i. goose egg : </strong>zero or nothing, especially a score of zero in a game</p>
        <p>I got a goose egg on the test because I didn't study.</p>
       
      </div>
      <hr/>
      <div>
        <p className='question'>D. Match the following phrasal verbs with their meanings.</p>
        <p>a. break down : to stop functioning</p>
        <p>b. check out : to leave a hotel</p>
        <p>c. fed up : tired of something or someone</p>
        <p>d. fill out : to complete a form</p>
        <p>e. get away : to escape</p>
        <p>f. give away : to give something to someone for free</p>
        <p>g. give up : to quit a habit</p>
        <p>h. look forward to : to wait anxiously for something or an event</p>
        <p>i. make up : to invent a story or lie</p>
        <p>j. pass away : to die</p>
        <p>k. put out : to extinguish</p>
        <p>l. take off : to remove clothes or shoes from the body, to depart as in airplane</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>A. Answer these questions.</p>
        <p className='question'>a. What does the word Renaissance mean? Which language is it derived from?</p>
        <p>= The word Renaissance means 'rebirth'. It is derived from French word 'renaitre'.</p>
        <p className='question'>b. What did the Greek scholars do in their new locations after leaving the Greek city?</p>
        <p>= The Greek scholars taught the Greek language and shared important books after leaving their city.</p>
        <p className='question'>c. How did 'new learning' teach people to think in different ways?</p>
        <p>= 'New Learning' taught people to think in different ways by inspiring them to create art, build beautiful buildings, and write great literature. It helped people become more curious and creative.</p>
        <p className='question'>d. Describe the artistic developments of Renaissance in brief.</p>
        <p>= The artistic developments of the Renaissance began in Florence and later spread to other Italian cities like Venice and Milan. As trade and banking made people rich, they started spending money on music, art, and poetry. Famous artists such as Leonardo da Vinci, Michelangelo, Raphael, and Brunelleschi created amazing works of art. In literature, writers like William Shakespeare and Cervantes became very well known. Shakespeare became one of the greatest literary figures of that time.</p>
        <p className='question'>e. Name the three Renaissance scientists who made great discoveries?</p>
        <p>= Name of the three Renaissance scientists are Galileo Galilei, Nicolas Copernicus and Sir Isaac Newton.</p>
        <p className='question'>f. Who developed the printing press? Which country was he from?</p>
        <p>= Johannes Gutenberg developed the printing press. He was from Germany. His invention made it easier to print books and helped spread knowledge quickly across Europe.</p>
        <p className='question'>g. Why is the development of the printing press considered as one of the gifts of Renaissance?</p>
        <p>= The development of the printing press is considered one of the gifts of the Renaissance because it made books easier and cheaper to produce. Before the press, books were handwritten and very expensive. With the printing press, more people could read and learn, helping to spread knowledge and ideas across Europe.</p>
        <p className='question'>h. Name the five famous explorers of the Renaissance?</p>
        <p>= The five famous explorers of the Renaissance were Christopher Columbus, Vasco de Gama, John Cabot, Ferdinand Magellan and Sir Francis Drake.</p>
        <p className='question'>i. Why do some people think of the Renaissance as the beginning of modern history?</p>
        <p>= People think of the Renaissance as the beginning of modern history because it brought great changes in art, architecture, literature, science, exploration, and culture. It encouraged learning, creativity, and new ways of thinking, which laid the foundation for the modern world.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. What do you infer from the reading? Tick (√) the best answer.</p>
        <p>a. Before the Renaissance…</p>
        <p>= education was limited to scholars and privileged</p>
        <p>b. Which statement is true?</p>
        <p>= The Greeks had a strong influence on Renaissance thinking</p>
        <p>c. What did the Renaissance do?</p>
        <p>= It caused people to make changes in their lives</p>
        <p>d. What were the major causes of the Renaissance?</p>
        <p>= printing, reading and learning</p>
      </div>
      <hr/>
      <div>
        <h3>Critical Thinking</h3>
        <p className='question'>a. Do you agree with Machiavelli's view that a good leader can do bad and dishonest things in order to preserve his power and protect his government? Explain.</p>
        <p>= I partly agree with Machiavelli's view. He believed that sometimes a leader must do bad or dishonest things to keep power and protect the government. This idea comes from his famous book The Prince, where he says it is better for a leader to be feared than loved if he cannot be both.
</p><p>
In some cases, a leader might face difficult situations where quick and tough decisions are needed. If those actions are for the safety and stability of the country, they might be understandable. For example, during war or crisis, a leader might need to act secretly or go against usual rules to protect people.
</p><p>
However, I also think that if a leader always uses lies or harmful methods, people will lose trust. A good leader should try to be honest and fair whenever possible. Power should not be more important than doing the right thing.
</p><p>
So, while sometimes hard choices are needed, a truly good leader should balance power with honesty and care for the people.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Do you think that art and literature are important assets of a country? Give reasons.</p>
        <p>= Yes, I think art and literature are very important assets of a country. They reflect the culture, traditions, and values of a nation. Through art and literature, people can express their feelings, ideas, and experiences. They help us understand our past and give us lessons for the future.
</p><p>
Art and literature also help to inspire people. Writers and artists use their work to talk about problems like poverty, inequality, and injustice. Their words and creations can touch people's hearts and make them think differently. In a country like Nepal, where we are trying to improve and solve many issues, art and literature can bring awareness and hope.
</p><p>
Books, poems, paintings, songs, and plays are not just for entertainment. They can also educate and motivate people. That's why we should respect artists and writers and encourage more young people to take interest in these fields.
</p><p>
So yes, I believe that art and literature are not just beautiful things, but powerful tools that help build a stronger and better country.

</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>a. Write an essay on “Literature is the reflection of society.”</p>
        <strong>Literature is the Reflection of Society</strong>
        <p>Since the beginning of human life, storytelling has been a way to share important information about society, life, and the world around us. In ancient times, people passed down stories orally through songs and spoken words. Literature is a form of expression where writers take their thoughts and turn them into stories, poems, or plays that others can understand and learn from.
</p><p>
Many authors have written about social, political, environmental, historical, and scientific topics in their works. Our rich past is preserved in books like the Ramayana, the Mahabharata, the Old Testament, and the Bible. Because of literature, people today can learn about their ancestors and understand how human life began.
</p><p>
Society creates literature because it reflects its traditions, customs, and religious beliefs. The quality and nature of this reflection depend on the writer's mindset—whether he or she has a modern or traditional way of thinking. That is why literature is like a mirror of society. It shows human emotions, actions, and both good and bad events, including social and political changes.
</p><p>
In this way, literature helps us understand ourselves and the world we live in, making it a valuable part of every society.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. It is said that today's reader is tomorrow's leader. Do you agree with this statement? Explain.</p>
        <strong>Today's Reader is Tomorrow's Leader</strong>
        <p>I agree with the statement that today's reader is tomorrow's leader. Reading plays a very important role in the overall development of a person. It helps build basic skills, improves language fluency, and enriches vocabulary. Reading also helps us gather ideas, understand different styles of writing, and speak confidently.
</p><p>
A person who reads regularly never feels lonely or bored. Books open up a magical world full of knowledge and imagination. They guide readers, make them wise, and teach them to think practically. Developing the habit of reading is one of the best things we can do for ourselves.
</p><p>
So, it is clear that if we want to become successful leaders in the future, we must start by being good readers today.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>c. Write a short biography of a national literary, artistic or historical figure you appreciate most.</p>
        <strong>Bhanubhakta Acharya: The First Nepali Poet</strong>
        <p>Bhanubhakta Acharya is one of the most respected literary figures in Nepal. He was born in 1814 in the Tanahun district. Bhanubhakta is famous for being the first poet to translate the great Indian epic, the Ramayana, from Sanskrit into Nepali. This made the story accessible to common Nepali people who did not understand Sanskrit.
</p><p>
Bhanubhakta's writing is known for its simplicity and beauty. He used everyday language, which helped spread literacy and inspired many Nepali writers after him. Because of his valuable contribution, he is often called “Adikavi,” meaning the first poet of Nepal.
</p><p>
His work helped to preserve and promote Nepali language and culture at a time when most literary works were written only in Sanskrit. Bhanubhakta's poetry remains popular today, and his birthday is celebrated as “Bhanubhakta Jayanti” in Nepal.
</p><p>
Bhanubhakta Acharya's dedication to literature and culture has made a lasting impact on Nepalese society, and he continues to inspire young writers and readers even today.

</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Complete the following sentences with correct relative pronouns and write whether the clauses are defining or non-defining.</p>
        <p>a. That's the house where I was born.</p>
        <p>= Defining clause</p>
        <br/>
        <p>b. My aunt Nita, whoa journalist, is coming to visit next week.</p>
        <p>= Non-defining clause</p>
        <br/>
        <p>c. People wholike outdoor activities will love our holidays.</p>
        <p>= Defining clause </p>
        <br/>
        <p>d. The early 1960s, when the Beatles first started, was a very exciting time in pop culture.</p>
        <p>= Non-defining clause</p>
        <br/>
        <p>e. My essay on Shakespeare, which I found quite difficult, got a really good mark in the end.</p>
        <p>= Non-defining clause</p>
        <br/>
        <p>f. The Mayans, who lived in Central America, built many stunning temples.</p>
        <p>= Non-defining clause</p>
        <br/>
        <p>g. That's the girl whose brother is in your class.</p>
        <p>= Defining clause</p>
        <br/>
        <p>h. The snake that was in the garden last week belongs to our next-door neighbor.</p>
        <p>= Defining clause</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Join the following pairs of sentences with an appropriate relative clauses.</p>
        <p>a. He is a musician. His albums have sold millions.</p>
        <p>= He is a musician whose albums have sold millions.</p>
        <br/>
        <p>b. Amelia speaks English and Chines fluently. She is from Shanghai.</p>
        <p>= Amelia, who is from Shanghai, speaks English and Chinese fluently.</p>
        <br/>

        <p>c. That's the stadium. Real Madrid plays there.</p>
        <p>= That's the stadium where Real Madrid plays.</p>
        <br/>
        <p>d. Dublin is my favourite city. It is the capital of Ireland.</p>
        <p>= Dublin is my favourite city, which is the capital of Ireland.</p>
        <br/>
        <p>e. The person was really helpful. They spoke to him.</p>
        <p>= The person to whom they spoke was really helpful.</p>
        <br/>
        <p>f. This smartphone takes great photos. I bought it last week.</p>
        <p>= This smartphone takes great photos, which I bought last week.</p>
      </div>
    </div>
  )
}

export default Artsandcreations
